import { TreeNodeReadDto } from '../_generated/api/structure'
import { buildStructureLink } from '../tools/link'
import { StructureType, StructureTypes } from './Structure'
import ApiModel from './ApiModel'

export default class DirectoryEntry extends ApiModel<TreeNodeReadDto> {
    get id() {
        return this.data.id ?? ''
    }

    get name() {
        return this.data.name ?? ''
    }

    get orderKey() {
        return this.data.orderKey ?? ''
    }

    get ancestorIdPath() {
        return this.data.ancestorIdPath ?? ''
    }

    get isArchived() {
        return this.data.archived ?? false
    }

    get parentId() {
        return this.data.parentId ?? undefined
    }

    get isRoot() {
        return this.parentId == null
    }

    get isLeaf() {
        return this.children.length === 0
    }

    get referenceType() {
        return (this.data.sourceType as StructureType) ?? StructureTypes.None
    }

    get referenceLink(): string {
        return buildStructureLink(this.referenceType, this.id)
    }

    get parentLink(): string {
        return buildStructureLink(StructureTypes.Project, this.parentId ?? '')
    }

    get childCount() {
        return this.children.length
    }

    get children() {
        const children = this.data.children ?? []
        return children.map((c) => new DirectoryEntry(c))
    }

    withChildren(children: DirectoryEntry[]) {
        return this.clone({ children: children.map(({ data }) => data) })
    }
}
